import { render, staticRenderFns } from "./sportbook-competition.vue?vue&type=template&id=9238fc40&scoped=true&"
import script from "./sportbook-competition.vue?vue&type=script&lang=js&"
export * from "./sportbook-competition.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-competition.vue?vue&type=style&index=0&id=9238fc40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9238fc40",
  null
  
)

export default component.exports